// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__oEvbD","productName":"Table_productName__jl8Ol"};